/* Karta produktu B2 w całym sklepie: wybór pojemności na karcie, do koszyka, okienko pojemności (telefon) z ilością.
   Jedno okienko na stronę (snippet lp-b2-karta-zasoby w layoucie); kliki łapane na dokumencie, więc działa też w kartach doczytanych później (podpowiedzi, polecane, ulubione). */
(() => {
  const sh = document.querySelector('[data-b2k-sh]');
  if (!sh || window.lpB2Karta) return;
  window.lpB2Karta = true;
  const $ = (s) => sh.querySelector(s);
  const ov = document.querySelector('[data-b2k-ov]');
  const T = JSON.parse(document.querySelector('[data-b2k-teksty]').textContent);
  let shCard = null, opener = null;

  const otworz = (od) => { opener = od; sh.hidden = ov.hidden = false; sh.querySelector('button').focus(); };
  const zamknij = () => { if (sh.hidden) return; sh.hidden = ov.hidden = true; if (opener) opener.focus(); opener = null; };

  /* koszyk: ta sama ścieżka co motyw (cart/add.js + sekcja szuflady + eventBus = okienko w rogu i licznik) */
  const doKoszyka = async (id, btn, ile = 1) => {
    btn.disabled = true;
    try {
      const r = await fetch(((window.routes && routes.cart_add_url) || '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: ile }], sections: 'cart-drawer' }) });
      const j = await r.json();
      if (!r.ok) throw j;
      const t = btn.textContent; btn.textContent = T.dodano; btn.classList.add('ok');
      setTimeout(() => { btn.textContent = t; btn.classList.remove('ok'); }, 2000);
      /* na stronach aplikacji (np. ulubione) sklep nie odsyła sekcji szuflady: wtedy szuflada pobiera koszyk sama */
      if (window.eventBus) { if (j.sections && j.sections['cart-drawer']) eventBus.emit('update:cart:drawer', Object.assign({}, j.items && j.items[0], { sections: j.sections })); else eventBus.emit('render:cart:drawer'); eventBus.emit('cart:added', {}); }
      if (window.wetheme && wetheme.updateCartCount) fetch(((window.routes && routes.cart_url) || '/cart') + '?view=compare').then(r => r.json()).then(c => wetheme.updateCartCount(c)).catch(() => {});
      zamknij();
    } catch (e) { alert((e && e.description) || T.blad); }
    btn.disabled = false;
  };

  const opcje = (card) => [...card.querySelectorAll('.dcard__vo')];
  const rysujSheet = (wyb) => {
    $('[data-b2-sh-o]').replaceChildren(...opcje(shCard).map(o => {
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'lp-b2-opt' + (o.dataset.v === wyb ? ' on' : ''); b.dataset.v = o.dataset.v;
      b.innerHTML = '<b></b><span>' + (o.dataset.s ? '<s></s>' : '') + '<i></i></span>';
      b.querySelector('b').textContent = o.firstChild.textContent.trim();
      b.querySelector('i').textContent = o.dataset.c;
      if (o.dataset.s) b.querySelector('s').textContent = o.dataset.s;
      return b;
    }));
    $('[data-b2-sh-add]').dataset.v = wyb;
  };

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (t.closest('[data-b2k-zamknij]')) return zamknij();
    const vo = t.closest('.dcard__vo');
    if (vo) {
      let card = vo.closest('.dcard');
      opcje(card).forEach(x => x.classList.toggle('on', x === vo));
      card.querySelector('.dcard__price').textContent = vo.dataset.c;
      const pr = card.querySelector('.dcard__prices'); let s = pr.querySelector('s');
      if (vo.dataset.s) { if (!s) { s = document.createElement('s'); pr.append(s); } s.textContent = vo.dataset.s; } else if (s) s.remove();
      pr.classList.toggle('is', !!vo.dataset.s);
      card.querySelector('.dcard__f--sale').textContent = vo.dataset.r ? '−' + vo.dataset.r + '%' : '';
      card.querySelector('[data-b2-add]').dataset.b2Add = vo.dataset.v;
      if (card.querySelector('.ambra-code-badge')) { const n = card.cloneNode(true); n.querySelectorAll('.ambra-code-badge').forEach(x => x.remove()); n.querySelector('.dcard__wl').replaceChildren(); card.replaceWith(n); }
      return;
    }
    const add = t.closest('[data-b2-add]');
    if (add) { const wyb = add.closest('.dcard')?.querySelector('.dcard__vo.on'); return doKoszyka(wyb ? wyb.dataset.v : add.dataset.b2Add, add); }
    if (t.closest('[data-b2-sheet]')) {
      shCard = t.closest('.dcard');
      const img = shCard.querySelector('.dcard__ph img');
      $('[data-b2-sh-img]').src = img ? img.currentSrc || img.src : '';
      $('[data-b2-sh-n]').replaceChildren(...shCard.querySelector('.dcard__tt').cloneNode(true).childNodes);
      const nm = shCard.querySelector('.dcard__nm'), br = shCard.querySelector('.dcard__br'), m = $('[data-b2-sh-m]');
      m.replaceChildren();
      if (nm) { const b = document.createElement('b'); b.textContent = nm.textContent; m.append((T.insp ? T.insp + ' ' : ''), b, br ? ' · ' + br.textContent : ''); }
      $('[data-b2-ilosc]').value = 1;
      rysujSheet(shCard.querySelector('.dcard__vo.on')?.dataset.v || opcje(shCard)[0]?.dataset.v);
      otworz(t.closest('[data-b2-sheet]'));
      return;
    }
    if (!sh.contains(t)) return;
    const opt = t.closest('.lp-b2-opt');
    if (opt) return rysujSheet(opt.dataset.v);
    const sa = t.closest('[data-b2-sh-add]');
    if (sa) return doKoszyka(sa.dataset.v, sa, Math.min(99, Math.max(1, parseInt($('[data-b2-ilosc]').value, 10) || 1)));
    const il = t.closest('[data-b2-il]');
    if (il) { const w = $('[data-b2-ilosc]'); w.value = Math.min(99, Math.max(1, (parseInt(w.value, 10) || 1) + +il.dataset.b2Il)); }
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape') zamknij(); });
})();
